import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import api from '../api/client';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }
      // console.log(token);
      try {
        const { data } = await api.get('/api/userprofile/get', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(data); // Or setUser(data.user), depending on your response
      } catch (err) {
        console.error('Error fetching user:', err);
        localStorage.removeItem('token');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/api/users/login', { email, password });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data.user;
  };

  const googleLogin = async (tokenId) => {
    const { data } = await api.post('/api/users/google-login', { tokenId });
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/api/users/register', payload);
    return data;
  };

  const resetPassword = async (email, newPassword) => {
    const { data } = await api.post('/api/users/reset-password', { email, newPassword });
    return data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    // window.location.href = '/';
  };

  const value = useMemo(() => ({
    user,
    login,
    logout,
    register,
    resetPassword,
    googleLogin,
    loading,
  }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
